import React from 'react';
import { connect } from 'react-redux';

import Template from './../../templates/Infoadd';
import { commonOperations } from './../../../reducks/common';
import { infoaddOperations } from './../../../reducks/infoadd'; 
import { infoaddSelectOperations } from './../../../reducks/infoaddSelect'; 

const mapStateToProps = state => ({
  currentTheme: state.common.theme,
});
const mapDispatchToProps = {
  //action: operation,
  doConfirmDialogOperation: commonOperations.confirmDialogOperation,
  doOpenDialogOperation: commonOperations.openDialogOperation,
  doCheckResponse: commonOperations.checkResponseOperation,
  doClearStore: commonOperations.storeInit,
  doSetShelterName: infoaddOperations.setShelterNameOperation,
  doResetSetaiInfo: infoaddOperations.resetSetaiInfoOperation,
  doSetKojinInfoList: infoaddOperations.setKojinInfoListOperation,
  doSetKojinInfo: infoaddOperations.setKojinInfoOperation,
  doSetSetaiInfo: infoaddOperations.setSetaiInfoOperation,
  doSetYearList: infoaddOperations.setYearListOperation,
  doSetKojinInfoDetail: infoaddOperations.setKojinInfoDetailOperation,
  doSetRegisteredKojinInfoList: infoaddOperations.setRegisteredKojinInfoListOperation,
  doSetKojinNumber: infoaddOperations.setKojinNumberOperation,
  doResetKojinInfoList: infoaddOperations.resetKojinInfoListOperation,
  doDeleteKojinInfo: infoaddOperations.deleteKojinInfoOperation,
  doGetKojin: infoaddOperations.getKojin,
  doSetKojin: infoaddOperations.setKojin,
  doSetEntryKubun: infoaddSelectOperations.setEntryKubunOperation,
  doGetEntryKubun: infoaddSelectOperations.getEntryKubun
};

class App extends React.Component {
  componentDidMount = async() =>{
    window.scrollTo(0, 0);
    document.title = "入所情報登録";
    
    this.props.doSetKojinInfo(0);
    this.props.doResetSetaiInfo();
    this.props.doSetYearList();
    console.log("入所区分："+ await this.props.doGetEntryKubun())
    if(await this.props.doGetEntryKubun() == 1){
    	document.getElementById("btnDialg").click();
	  }else if(await this.props.doGetEntryKubun() == 2){
		  document.getElementById("btnGet").click();
	  }

  }
  componentWillMount() {
    // this.props.doClearStore();
    // localStorage.clear();
  }

  render() {
    return (
    
      <Template {...this.props} />
      
    );
  }
}

const ContainerApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
export default ContainerApp;
